export { EditCustomPageResource as default } from './resources';
